import { render, staticRenderFns } from "./MyClientsList.vue?vue&type=template&id=1759f578&scoped=true&"
import script from "./MyClientsList.vue?vue&type=script&lang=js&"
export * from "./MyClientsList.vue?vue&type=script&lang=js&"
import style0 from "./MyClientsList.vue?vue&type=style&index=0&id=1759f578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1759f578",
  null
  
)

export default component.exports